<template>
  <button
    class="inline-flex items-center justify-center text-sm rounded py-1 px-2.5 gap-1 hover:brightness-125"
  >
    <slot />
  </button>
</template>
